<template>
  <div>
    <p v-if="form.approvalStatus">
      Trạng thái:
      <a-tag :color="statusColor(form.approvalStatus)">
        {{ statusTitle }}
      </a-tag>
    </p>

    <p v-if="form.form">
      <strong>Loại</strong>
      {{ form.form.formName }}
    </p>
    <p>
      <strong>Mã</strong>
      {{ form.code }}
    </p>
    <p>
      <strong>Tiêu đề</strong>
      {{ form.title }}
    </p>
    <p>
      <strong>Mô tả</strong>
      {{ form.description }}
    </p>
    <template
      ng-if="form.createdFormFields && form.createdFormFields.length > 0"
    >
      <ToView
        v-for="field in form.createdFormFields"
        :key="field.id"
        :field="field"
      />
    </template>
    <a-button
      type="dashed"
      size="small"
      @click="visibleHistory = !visibleHistory"
      v-if="form.approvalStatus && form.approvalStatus !== 'Draft'"
    >
      <a-icon :type="!visibleHistory ? 'eye' : 'eye-invisible'" />
      Xem lịch sử duyệt
    </a-button>
    <ApprovalHistory :onClose="onCloseHistory" :visible="visibleHistory" />
    <hr />
    <ApprovalBtns :form="form" />
  </div>
</template>
<script>
import ToView from "@/components/DataToView/DataToView.vue";
import ApprovalBtns from "@/components/ApprovalBtns";
import ApprovalHistory from "@/components/ApprovalHistory.vue";

export default {
  components: { ToView, ApprovalBtns, ApprovalHistory },
  data() {
    return {
      submiting: false,
      visibleHistory: false
    };
  },
  computed: {
    form() {
      return this.$store.state.form;
    },
    statusTitle(status) {
      if (this.form && this.form.approvalStatus) {
        const status = this.form.approvalStatus;
        if (status === "Approved") {
          return "Đã duyệt";
        } else if (status === "Pending") {
          return "Đang trình duyệt";
        } else if (status === "Rejected") {
          return "Không duyệt";
        } else if (status === "Draft") {
          return "Bản nháp";
        } else {
          return "Yêu cầu chỉnh sửa";
        }
      } else {
        return undefined;
      }
    }
  },
  methods: {
    statusColor(status) {
      if (status === "Approved") {
        return "green";
      } else if (status === "Pending") {
        return "blue";
      } else if (status === "Rejected") {
        return "red";
      } else if (status === "Draft") {
        return "gray";
      } else {
        return "orange";
      }
    },
    onCloseHistory() {
      this.visibleHistory = false;
    }
  }
};
</script>
